/**
 * Organization-based route helpers and constants
 */

export const organizationRoutes = {
    dashboard: (orgId: string) => `/organization/${orgId}`,
    achievements: (orgId: string) => `/organization/${orgId}/achievements`,
    library: (orgId: string) => `/organization/${orgId}/library`,
    bookmarks: (orgId: string) => `/organization/${orgId}/bookmarks`,
    lastViewedVideos: (orgId: string) => `/organization/${orgId}/last-viewed-videos`,
    profile: (orgId: string) => `/organization/${orgId}/profile`,
    membershipPlan: (orgId: string) => `/organization/${orgId}/membership-plan`,
    offers: (orgId: string) => `/organization/${orgId}/offers`,
    chat: (orgId: string) => `/organization/${orgId}/chat`,
    offerDetail: (orgId: string, offerId: string) => `/organization/${orgId}/offers/${offerId}`,
    invite: (orgId: string) => `/organization/${orgId}/invite`,
    video: (orgId: string, videoId: string, source?: string, folderId?: string) => {
        const baseUrl = `/organization/${orgId}/video/${videoId}`;
        const params = new URLSearchParams();
        if (source) params.set('source', source);
        if (folderId) params.set('folderId', folderId);
        const queryString = params.toString();
        return queryString ? `${baseUrl}?${queryString}` : baseUrl;
    }
} as const;

/**
 * Common navigation parameter types
 */
export interface VideoNavigationParams {
    orgId: string;
    videoId: string;
    source?: string;
    folderId?: string;
}

export interface OrganizationNavigationParams {
    orgId: string;
}